module.exports = __webpack_public_path__ + "img/msi.c369658c.jpg";